import { useIntl } from '@capsicum/common';
import { useMemo } from 'react';

type UseProductPageTextsProps = {
	amountNeeded: number;
	partnerShortName?: string;
};

export const useProductPageTexts = ({ amountNeeded, partnerShortName }: UseProductPageTextsProps) => {
	const { $t } = useIntl();

	const texts = useMemo(
		() => ({
			availableIn: $t('rewards.fanshop.availableIn'),
			balanceAfter: $t('rewards.fanshop.orderSummary.balanceAfter'),
			buyFanTokens: $t('rewards.buyFanTokens'),
			category: $t('rewards.fanshop.category'),
			comingSoon: $t('rewards.fanshop.comingSoon'),
			confirmationMessage: $t('rewards.fanshop.placeOrder.confirmMessageSheet'),
			deliveryAddress: $t('rewards.fanshop.placeOrder.deliveryAddress'),
			details: $t('rewards.fanshop.product.productDetails'),
			eventDate: $t('rewards.fanshop.product.eventDate'),
			faq: $t('rewards.fanshop.faq'),
			faqTitle: $t('rewards.fanshop.product.faqTitle'),
			fieldsWithEmptyValuesError: $t('rewards.fanshop.placeOrder.fieldsWithEmptyValuesErrorDescription'),
			goToFanShop: $t('rewards.fanshop.placeOrder.goToFanShopText'),
			importantInformationText1Experience: $t('rewards.fanshop.product.importantInformationText1Experience'),
			importantInformationText1Merchandise: $t('rewards.fanshop.product.importantInformationText1Merchandise'),
			importantInformationText1Ticket: $t('rewards.fanshop.product.importantInformationText1'),
			importantInformationText2Experience: $t('rewards.fanshop.product.importantInformationText2Experience'),
			importantInformationText2Merchandise: $t('rewards.fanshop.product.importantInformationText2Merchandise'),
			importantInformationText2Ticket: $t('rewards.fanshop.product.importantInformationText2'),
			importantInformationText3Experience: $t('rewards.fanshop.product.importantInformationText3Experience'),
			importantInformationText3Merchandise: $t('rewards.fanshop.product.importantInformationText3Merchandise'),
			importantInformationText3Ticket: $t('rewards.fanshop.product.importantInformationText3'),
			importantInformationTitle: $t('rewards.fanshop.product.importantInformationTitle'),
			itemAmount: $t('rewards.fanshop.orderSummary.itemAmount'),
			limitExceededError: $t('rewards.fanshop.orderSummary.productOrderAmountLimitExceededError'),
			matchDate: $t('rewards.fanshop.product.matchDate'),
			outOfStock: $t('rewards.fanshop.outOfStock'),
			package: 'Package Product',
			proofOfTravel: $t('rewards.fanshop.placeOrder.proofOfTravelRewardPoints'),
			quantity: $t('rewards.fanshop.orderSummary.quantity'),
			recipientName: $t('rewards.fanshop.placeOrder.recipientName'),
			redeemButton: $t('rewards.fanshop.product.redeemButton'),
			rewardPoints: $t('rewards.rewardPoints'),
			stadium: $t('rewards.fanshop.product.stadium'),
			tickets: $t('rewards.fanshop.product.tickets'),
			title: $t('rewards.fanshop.product.title'),
			titleOrderSummary: $t('rewards.fanshop.orderSummary.title'),
			titlePlaceOrder: $t('rewards.fanshop.placeOrder.title'),
			tokensNeeded: $t('rewards.fanshop.product.tokenNeeded', {
				amount: amountNeeded,
				token: partnerShortName
			}),
			total: $t('rewards.fanshop.orderSummary.total'),
			tryAgain: $t('global.tryAgainLater'),
			warningText: $t('rewards.fanshop.placeOrder.warningText')
		}),
		[$t, amountNeeded, partnerShortName]
	);

	return texts;
};
